import React from 'react'

const SingleCategoryBox = ({ ...props }) => {
	return (
		<div
			className='rounded-lg categoryBox'
			style={{
				background:
					'radial-gradient(123.64% 113.12% at 100% 100%, rgba(235, 0, 255, 0.24) 0%, rgba(235, 0, 255, 0) 100%), radial-gradient(110% 110% at 15% 12.61%, rgba(74, 19, 108, 0.55) 0%, rgba(19, 31, 108, 0) 100%)',
			}}
		>
			<img src={props.categoryImg} alt='Category icon'></img>
			<h4>{props.categoryName}</h4>
		</div>
	)
}

export default SingleCategoryBox
